import { AlertOriginTypesEnum } from '../../../utilities/Constants';
import { IAlertListModel } from '../../../interfaces/INote';
import { NavLink } from 'react-router-dom';

export interface IActionButtonsProps {
    item: IAlertListModel;
    navigationUrl: string;
    onEditClick: (item: IAlertListModel) => void;
    onMarkCaseTriggerAsReadClick: (alertGuid: string, openCaseTriggerDetailPopup?: boolean) => void;
    onViewNoteClick: (item: IAlertListModel) => void;
}

export function AlertViewEditActionButtons(props: IActionButtonsProps) {
    switch (props.item.originTypeId) {
        case AlertOriginTypesEnum.PackageSettlementNote:
        case AlertOriginTypesEnum.ZoneNote:
        case AlertOriginTypesEnum.StrategyNote:
        case AlertOriginTypesEnum.CaseNote:
            return (
                <>
                    <button
                        className="btn btn-no-bg"
                        onClick={() => {
                            props.onViewNoteClick(props.item);
                        }}
                    >
                        <i className="fal fa-lg fa-eye" />
                    </button>
                    {props.item.allowEdit ? (
                        <button
                            className="btn btn-no-bg"
                            onClick={() => props.onEditClick(props.item)}
                        >
                            <i className="fal fa-lg fa-pen" />
                        </button>
                    ) : null}
                </>
            );
        case AlertOriginTypesEnum.CaseTrigger:
            return (
                <>
                    <button
                        className="btn btn-no-bg"
                        onClick={() => props.onMarkCaseTriggerAsReadClick(props.item.guid, true)}
                    >
                        <i className="fal fa-lg fa-eye" />
                    </button>
                    {!props.item.alertReadForLoggedInUser ? (
                        <button
                            className="btn btn-no-bg"
                            onClick={() => props.onMarkCaseTriggerAsReadClick(props.item.guid)}
                        >
                            <i className="fal fa-lg fa-check" />
                        </button>
                    ) : null}
                </>
            );
        case AlertOriginTypesEnum.Report:
            return (
                <>
                    <NavLink to={props.navigationUrl} target="_blank">
                        <button className="btn btn-no-bg">
                            <i className="fal fa-lg fa-eye" />
                        </button>
                    </NavLink>
                </>
            );
        default:
            return null;
    }
}
